import React from 'react';

function CTAButton({ href, text, primary = false, className = '' }) {
  const baseStyle = "inline-block px-8 py-3 rounded-md font-semibold text-center transition duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2";
  const primaryStyle = "bg-primary text-white hover:bg-primary-light focus:ring-primary";
  const secondaryStyle = "bg-accent text-white hover:bg-accent-light focus:ring-accent"; // Accent color as secondary

  const styles = `${baseStyle} ${primary ? primaryStyle : secondaryStyle} ${className}`;

  if (href) {
    return (
      <a href={href} className={styles}>
        {text}
      </a>
    );
  }

  return (
    <button type="button" className={styles}>
      {text}
    </button>
  );
}

export default CTAButton; 